import { render } from "./ExpirationMessage.vue?vue&type=template&id=55a5d954&scoped=true"
import script from "./ExpirationMessage.vue?vue&type=script&lang=js"
export * from "./ExpirationMessage.vue?vue&type=script&lang=js"

import "./ExpirationMessage.vue?vue&type=style&index=0&id=55a5d954&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a5d954"]])

export default __exports__